import { useEffect, useState } from "react"
import { Link, useNavigate } from  "react-router-dom"
import axiosInstance from "../../hooks/axiosInstance"
import { toast } from "react-toastify"
import shuffleArray from "../../hooks/useArrayShuffle"
import Loader from "../../components/utilities/Loader/Loader"
import { Pagination } from '@mui/material';
import AssociationDetails from "../../components/AssociationAdmin/AssociationDetails"

export default function OpenAssociationsPage() {
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [associations, setAssociations] = useState([])
    const [currentAssociation, setCurrentAssociation] = useState(null)
    const  [mode, setMode] = useState("")

    //  state for pagination
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [pageCount, setPageCount] = useState(1);
    
    //  pagination function
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const fetchOpenAssociations = () => {
        setLoading(true)
        axiosInstance.post(`/user/associations/open?page=${page}`, {membership_mode: mode})
              .then(response => {
                shuffleArray.fisherYatesShuffle(response.data.data.data, response.data.data.length)
                setAssociations(response.data.data.data)
                const pageCount = Math.ceil(response.data.data.total / response.data.data.per_page);
                setPageCount(pageCount)
              })
              .catch(err => {
                toast.error('An error occured. Please, try again')
              })
              .finally(() => setLoading(false))
    }

    const joinAssociation = (id) => {
        setLoading(true)
        axiosInstance.post(`/user/associations/open/join`, {associationId: id})
            .then(res => {
                toast.success(res.data.message)
                fetchOpenAssociations()
                navigate('/app/applications')
            })
            .catch(err => {
                toast.error('An error occured. Please, try again')
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        fetchOpenAssociations()
    }, [page])
    return (
        <>
            {/* <!-- start page title --> */}
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">Open Associations</h4>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link to="/app">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Open Associations</li>
                            </ol>
                        </div>

                    </div>
                </div>
            </div>
            {/* <!-- end page title --> */}


            <div className="card">
                <div className="card-body">
                    <div className="row g-3">
                        {/* <div className="col-xxl-4 col-lg-6">
                            <div className="search-box">
                                <input type="text" className="form-control" placeholder="Search to invitations..." />
                                <i className="ri-search-line search-icon"></i>
                            </div>
                        </div>
                        {/* <!--end col--> */}
                        {/* <div className="col-xxl-3 col-lg-6">
                            <input type="text" className="form-control" data-date-format="d M, Y" data-range-date="true" placeholder="Select date" />
                        </div> */}
                        <div className="col-xxl-4 col-lg-4">
                            <select 
                                className="form-control"
                                name="mode"
                                value={mode}
                                onChange={(e) => setMode(e.target.value)}
                            >
                                <option value="">All</option>
                                <option value="free">Free</option>
                                <option value="Paid">Paid</option>
                            </select>
                        </div>
                        {/* <!--end col--> */}
                        <div className="col-xxl-1 col-lg-4">
                            <button className="btn btn-primary w-100" onClick={fetchOpenAssociations}>
                                <i className="ri-equalizer-line align-bottom me-1"></i> Filter
                            </button>
                        </div>
                    </div>
                    {/* <!--end row--> */}
                </div>
            </div>

            <div className="row">
                {associations.length  > 0 && associations.map(association => (
                    <div className="col-xxl-3 col-sm-6 project-card" key={association.id}>
                        <div className="card card-height-100">
                            <div onClick={() => setCurrentAssociation(association)} className="card-body cursor-pointer" data-bs-toggle="offcanvas" data-bs-target="#association-view-offcanvas">
                                <div className="d-flex flex-column h-100">
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <span className={`badge ${association.membership_mode == 'free' ? 
                                                'badge-gradient-warning': 'badge-gradient-secondary'} mb-4 text-capitalize`}>
                                                {association.membership_mode}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="d-flex mb-0">
                                        <div className="flex-shrink-0 me-3">
                                            <div className="avatar-sm">
                                                <span className="avatar-title bg-warning-subtle rounded p-2">
                                                    <img src="/assets/images/brands/slack.png" alt="" className="img-fluid p-1" />
                                                </span>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <h5 className="mb-1 fs-15"><a href="apps-projects-overview.html" className="text-body">
                                                {association.name}
                                            </a></h5>
                                            <p className="text-muted text-truncate-two-lines mb-3">{association.description} </p>
                                        </div>
                                    </div>
                                    <div className="mt-auto">
                                        <div className="d-flex mb-2">
                                            <div className="flex-grow-1">
                                                <div>Members</div>
                                            </div>
                                            <div className="flex-shrink-0">
                                                <div>{association?.members_count}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            {/* <!-- end card body --> */}
                            <div className="card-footer bg-transparent border-top-dashed py-2">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        {/* <div className="avatar-group">
                                            <a href="javascript: void(0);" className="avatar-group-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Darline Williams">
                                                <div className="avatar-xxs">
                                                    <img src="/assets/images/users/avatar-2.jpg" alt="" className="rounded-circle img-fluid" />
                                                </div>
                                            </a>
                                            <a href="javascript: void(0);" className="avatar-group-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Sylvia Wright">
                                                <div className="avatar-xxs">
                                                    <div className="avatar-title rounded-circle bg-secondary">
                                                        S
                                                    </div>
                                                </div>
                                            </a>
                                        </div> */}
                                    </div>
                                    <div className="flex-shrink-0">
                                        <a onClick={() => joinAssociation(association.id)} type="button" className="btn btn-soft-primary btn-sm flex-shrink-0 ms-2">
                                            Join
                                        </a>
                                    </div>
                                </div>

                            </div>
                            {/* <!-- end card footer --> */}
                        </div>
                        {/* <!-- end card --> */}
                    </div>
                ))}
                {associations.length == 0 && (
                    <div className="col-sm-12 alert alert-info text-center">
                        No record found
                    </div>
                )}
                {/* <!-- end col --> */}
            </div>
            {/* <!-- end row --> */}

            <div className="row g-0 text-center text-sm-start align-items-center mb-4">
                {/* <div className="col-sm-6">
                    <div>
                        <p className="mb-sm-0 text-muted">Showing <span className="fw-semibold">1</span> to <span className="fw-semibold">10</span> of <span className="fw-semibold text-decoration-underline">12</span> entries</p>
                    </div>
                </div> */}
                {/* <!-- end col --> */}
                <div className="col-sm-12 d-flex justify-content-end">
                    <Pagination 
                        onChange={handlePageChange}  
                        count={pageCount} 
                        color="primary" 
                        shape="rounded"
                        size="small"
                        page={page}
                    />
                </div>
                {/* <!-- end col --> */}
                {loading && <Loader />}
            </div>
            {/* <!-- end row --> */}

            {/* <!-- Association View --> */}
            <div className="offcanvas offcanvas-end border-0" tabindex="-1" id="association-view-offcanvas">
                <div className="d-flex align-items-center bg-primary bg-gradient p-3 offcanvas-header">
                    <h5 className="m-0 me-2 text-white">Association Profile</h5>

                    <button type="button" className="btn-close btn-close-white ms-auto" id="customizerclose-btn"
                        data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body p-0 bg-light">
                    <div data-simplebar className="h-100">
                        <div className="p-4">
                            <AssociationDetails currentAssociation={currentAssociation} />
                        </div>
                    </div>
                </div>
                <div className="offcanvas-footer border-top p-3 text-center">
                    <div className="row">
                        <div className="col-6">
                            <button data-bs-dismiss="offcanvas" type="button" className="btn btn-light w-100" id="reset-layout">Cancel</button>
                        </div>
                        <div className="col-6">
                            <a onClick={() => joinAssociation(currentAssociation?.id)} data-bs-dismiss="offcanvas" type="button" className="btn btn-primary w-100">Join</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}